module.exports = __webpack_public_path__ + "static/media/moon.17064efa.png";